import React, { Fragment, memo } from "react";
import { connect } from "react-redux";
import AppHeader from "./Layout/AppHeader";
import AppSidebar from "./Layout/AppSidebar";
import AppTheme from "./Layout/AppTheme";

const IntroLayout = ({ numberOfMenus, match, children, disableTheme, className, reduxUserRights }) => {
  const _isSidebarVisible = reduxUserRights.findIndex(_ => _["key"] === "LAYOUT/DISABLE_SIDEBAR") !== -1 ? false : true;

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        {_isSidebarVisible && <AppSidebar />}
        <div className="app-main__outer">
          <div className={`app-main__inner`}>{children}</div>
        </div>
      </div>
      {!disableTheme && <AppTheme />}
    </Fragment>
  );
};

IntroLayout.defaultProps = {
  className: ""
}

const mapStateToProps = state => ({
  numberOfMenus: state.UserOptions.menuItems.length,
  reduxUserRights: state.UserOptions.rights
})

export default memo(connect(mapStateToProps, null)(IntroLayout));
